module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "toc"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003"
    }
  }, [_vm._v("CHAPTER 1. THE COUNCIL OF WAYS AND MEANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004"
    }
  }, [_vm._v("CHAPTER 2. DIGGING FOR TREASURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("CHAPTER 3. BEING DETECTIVES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4. GOOD HUNTING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5. THE POET AND THE EDITOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6. NOEL’S PRINCESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7. BEING BANDITS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8. BEING EDITORS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9. THE G. B.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10. LORD TOTTENHAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11. CASTILIAN AMOROSO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12. THE NOBLENESS OF OSWALD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13. THE ROBBER AND THE BURGLAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14. THE DIVINING-ROD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15. ‘LO, THE POOR INDIAN!’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16. THE END OF THE TREASURE-SEEKING")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    attrs: {
      "id": "link2HCH0001"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre9",
    attrs: {
      "id": "calibre_pb_1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0